  <template>
  <div class="login-container">
    <div class="logo">
      <img v-if="!isIstore" style="height: 60px" src="../../assets/sfclogo.png" />
    </div>
    <el-button v-if="(!showSwitchButton || isQrMode) && !isCode" type="text" @click="changeLog()" class="hidden-toggle-btn corner-toggle-btn" :class="{ 'corner-toggle-btn--visible': isQrMode }">
      <svg-icon icon-class="qrcode" />
    </el-button>
    <el-button v-if="(!showSwitchButton || isQrMode) && isCode" type="text" @click="changeLog()" class="hidden-toggle-btn corner-toggle-btn" :class="{ 'corner-toggle-btn--visible': isQrMode }">
      <svg-icon icon-class="user" />
    </el-button>
    <el-form
      ref="loginForm"
      :model="loginForm"
      :rules="loginRules"
      class="login-form"
      auto-complete="on"
      label-position="left"
    >
      <h3 class="title">

        {{ isIstore ? '信息化管理平台' : '三态股份信息化管理平台' }}
      </h3>
      <el-row v-show="!isCode">
        <el-form-item prop="username" :error="errorMsg">
          <span class="svg-container">
            <svg-icon icon-class="user" />
          </span>
          <el-input
            v-model="loginForm.username"
            name="username"
            type="text"
            auto-complete="on"
            placeholder="用户名"
            @blur="checkUser"
            @keyup.enter.native="checkUser"
          />
        </el-form-item>
        <el-form-item prop="password">
          <span class="svg-container">
            <svg-icon icon-class="password" />
          </span>
          <el-input
            :type="pwdType"
            v-model="loginForm.password"
            @keyup.enter.native="handleLogin"
            name="password"
            auto-complete="on"
            placeholder="密码"
            ref="userPwd"
          />
          <span class="show-pwd" @click="showPwd">
            <svg-icon
              :icon-class="pwdType === 'password' ? 'eye' : 'eye-open'"
            />
          </span>
        </el-form-item>
        <el-button
          type="text"
          size="small"
          @click="
            $router.push({
              name: 'findPassword',
              params: { name: loginForm.username },
            })
          "
          >忘记密码</el-button
        >
        <div class="clear"></div>
        <el-form-item>
          <el-button
            :loading="loading"
            type="primary"
            style="width: 100%"
            @click.native.prevent="handleLogin"
            :disabled="validateFalse"
            >登录</el-button
          >
        </el-form-item>
      </el-row>
      <div class="code-tab" v-show="isCode">
        <!-- <div class="login-methods" v-if="hasFeishuTestPlatform()">
          <button type="button" class="login-btn" @click="selectLoginMethod('dingding')" :class="{ active: selectedLoginMethod === 'dingding' }">
            钉钉扫码
          </button>
          <button type="button" class="login-btn" @click="selectLoginMethod('feishu')" :class="{ active: selectedLoginMethod === 'feishu' }">
            飞书扫码
          </button>
        </div> -->
        <div class="qrcode-box">
          <div class="qrcode-card">
            <div id="login_container"></div>
            <span class="fs-corner fs-corner--tl"></span>
            <span class="fs-corner fs-corner--tr"></span>
            <span class="fs-corner fs-corner--bl"></span>
            <span class="fs-corner fs-corner--br"></span>
          </div>
        </div>
        <p class="qr-hint">请打开 <b>飞书 App</b>，扫一扫上方二维码登录</p>
        <p class="qr-refresh" v-if="isCode && selectedLoginMethod === 'feishu'" @click="retryFeishuQR">二维码未显示？点击刷新</p>
        <p class="security-tip">🔒 为保障账号安全，已停用账号密码登录，请使用飞书扫码登录</p>
      </div>
      <el-row v-if="showSwitchButton && !isQrMode" style="margin: 10px auto; text-align: center">
        <el-button plain size="mini" v-if="!isCode" @click="changeLog()"
          >扫码登录</el-button
        >
        <el-button plain size="mini" v-if="isCode" @click="changeLog()"
          >账号密码登录</el-button
        >
      </el-row>
    </el-form>
    <div class="footer-bottom">
      Copyright © 2021 <a href="https://beian.miit.gov.cn/#/Integrated/recordQuery" target="_blank">{{ editionStr }}</a> All right reserved
    </div>
  </div>
</template>

<script>
import { validateUser } from '@/api/login'
import { getIp, toLink } from '@/utils/index'
// import { getPowerInfo } from '@/utils/auth'
// import { getDepartTree } from '@/api/role.js'
// import { getStyle } from '@/api/style.js'

export default {
  name: 'Login',
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('密码不能为空'))
      } else if (value.length < 5) {
        callback(new Error('密码不能小于5位'))
      } else {
        callback()
      }
    }

    return {
      loginForm: {
        username: '',
        password: ''
      },
      loginRules: {
        password: [
          { required: true, trigger: 'blur', validator: validatePass }
        ]
      },
      loading: false,
      pwdType: 'password',
      redirect: undefined,
      isOldUser: '',
      isFirstLogin: '',
      errorMsg: '',
      validateFalse: false,
      isCode: process.env.VUE_APP_SWITCH_BUTTON !== '1',
      dingLoginProcessing: false,
      selectedLoginMethod: 'feishu',
      fsLoginProcessing: false,
      // 飞书扫码 SDK / 二维码渲染状态
      sdkLoaded: false,
      sdkReloadTried: false,
      sdkWatchdog: null,
      qrRetryCount: 0,
      qrCheckTimer: null,
      // feishu_goto: 'https://passport.feishu.cn/suite/passport/oauth/authorize?client_id=cli_a9477bbde37a5bc9&response_type=code&scope=openid&state=STATE&redirect_uri=' + encodeURIComponent('http://local.sfccorps.com:5186/verificationCode?loginfrom=feishu')
      feishu_goto: ''
    }
  },
  computed: {
    editionStr() {
      let str = '粤ICP备15079153号-1'
      if (window.location.host.indexOf('szecommerce.com') > -1) {
        str = '粤ICP备15079153号-1'
      } else if (window.location.host.indexOf('suntekcorps.cn') > -1) {
        str = '粤ICP备15079153号-2'
      } else {
        str = '粤ICP备15050246号-7'
      }
      return str
    },
    isIstore() {
      return window.location.host.indexOf('szecommerce.com') > -1 || window.location.host.indexOf('suntekcorps.cn') > -1
    },
    showSwitchButton() {
      return process.env.VUE_APP_SWITCH_BUTTON === '1'
    },
    // URL 带 loginMode=qr：飞书二维码在页面内渲染，不跳飞书授权页
    isQrMode() {
      return !!(this.$route.query && this.$route.query.loginMode === 'qr')
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        console.log(route,'route')
        if (route.query && route.query.redirect) {
          let fullurl = route.query.redirect
          let url = fullurl.split('?')[0]

          // 处理云文档 token 失效去掉 code 兼容需求管理系统的需求id 的？被 转义成 %3D
          Object.keys(route.query).forEach((key,index) => {
            if (key !== 'redirect' && key !== 'code') {
              url += (url.includes('?')?'&':'?') + key + '=' + route.query[key]
            }
            if(key === 'redirect'){
              if(route.query[key].includes('?')){
                route.query[key].split('?')[1].split('&').forEach(item => {
                  if(item.split('=')[0] !== 'code'){
                    // 修复：分隔符按"url 是否已有 ?"判断，原来的 index===0 会拼出多个 ?
                    url += (url.includes('?') ? '&' : '?') + item
                  }
                })
              }
            }
          })
          localStorage.setItem('redirect', url)
          this.redirect = url
        } else {
          // 本次登录没有 redirect：清掉可能残留的旧值，避免普通登录被旧 SSO redirect 带偏
          localStorage.removeItem('redirect')
        }
      },
      immediate: true
    },
    handler(newval, oldval) {
      if (newval) {
        this.$nextTick(() => {
          this.$refs.password.focus()
        })
      }
    }
  },
  created() {
    // this.getUserIp()
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleMessage)
    if (this.qrCheckTimer) {
      clearTimeout(this.qrCheckTimer)
      this.qrCheckTimer = null
    }
    if (this.sdkWatchdog) {
      clearTimeout(this.sdkWatchdog)
      this.sdkWatchdog = null
    }
  },
  mounted() {
    if (this.redirectToFeishuOAuthIfNeeded()) {
      return
    }
    this.loadFeishuSDK()

    if (typeof window.addEventListener !== 'undefined') {
      window.addEventListener('message', this.handleMessage, false)
    } else if (typeof window.attachEvent !== 'undefined') {
      window.attachEvent('onmessage', this.handleMessage)
    }
  },
  methods: {
    // getUserIp() {
    //   getLocalIp().then((res) => {
    //     console.log(res, 'ip')
    //     this.$store.dispatch('setUserIp', res.data || '')
    //   }).catch(() => {
    //     this.$store.dispatch('setUserIp', '')
    //   })
    // },
    changeLog() {
      this.isCode = !this.isCode
      if (this.isCode) {
        if (this.redirectToFeishuOAuthIfNeeded()) {
          return
        }
        this.$nextTick(() => {
          this.initLoginQR()
        })
      }
    },
    hasFeishuTestPlatform() {
      return true
    },
    selectLoginMethod(method) {
      this.selectedLoginMethod = method
      if (this.redirectToFeishuOAuthIfNeeded()) {
        return
      }
      this.initLoginQR()
    },
    shouldUseFeishuQrFallback() {
      return this.isQrMode
    },
    redirectToFeishuOAuthIfNeeded() {
      if (!this.isCode || this.selectedLoginMethod !== 'feishu' || this.shouldUseFeishuQrFallback()) {
        return false
      }
      window.location.replace(this.getFeishuGoto())
      return true
    },
    getVerificationCodePath() {
      let path = '/verificationCode'
      if (this.redirect) {
        path += '?redirect=' + encodeURIComponent(this.redirect)
      }
      return path
    },
    getFeishuGoto() {
      const redirectUri = process.env.NODE_ENV === 'production'
        ? 'https://account.suntekcorps.com/verificationCode?loginfrom=feishu'
        : 'http://account.sfccorps.com/verificationCode?loginfrom=feishu'
      // 不把 redirect 放进飞书 state：飞书回跳会对 state 解码一次，导致 redirect 内层的
      // &state=/&response_type= 等参数泄漏成顶层参数、state 变数组、被逗号黏连损坏。
      // redirect 已存在 localStorage('redirect')，由 verificationCode 从 localStorage 读取。
      const state = 'STATE'
      return 'https://passport.feishu.cn/suite/passport/oauth/authorize?client_id=cli_a9477bbde37a5bc9&response_type=code&scope=openid&state=' + state + '&redirect_uri=' + encodeURIComponent(redirectUri)
    },
    // 加载飞书扫码登录 SDK（已加载缓存判断 + 看门狗 + 失败重载兜底）
    loadFeishuSDK() {
      // 已加载过（页面缓存或上次注入），直接就绪
      if (window.QRLogin) {
        this.sdkLoaded = true
        if (this.isCode) this.initLoginQR()
        return
      }
      // 看门狗：CDN 偶发卡住时 onload/onerror 都不触发，超时后重载一次或走兜底
      if (this.sdkWatchdog) clearTimeout(this.sdkWatchdog)
      this.sdkWatchdog = setTimeout(() => {
        this.sdkWatchdog = null
        if (window.QRLogin) return // 期间已就绪
        if (!this.sdkReloadTried) {
          this.sdkReloadTried = true
          this.loadFeishuSDK()
        } else {
          this.sdkLoaded = true
          if (this.isCode) this.initLoginQR()
        }
      }, 8000)

      const script = document.createElement('script')
      script.src = 'https://lf-package-cn.feishucdn.com/obj/feishu-static/lark/passport/qrcode/LarkSSOSDKWebQRCode-1.0.3.js'
      script.async = true
      script.onload = () => {
        if (this.sdkWatchdog) { clearTimeout(this.sdkWatchdog); this.sdkWatchdog = null }
        this.sdkLoaded = true
        if (this.isCode) this.initLoginQR()
      }
      // CDN 加载失败：未重载过则重载一次（CDN 抖动常为瞬时），否则走渲染兜底
      script.onerror = () => {
        if (this.sdkWatchdog) { clearTimeout(this.sdkWatchdog); this.sdkWatchdog = null }
        if (!this.sdkReloadTried) {
          this.sdkReloadTried = true
          this.loadFeishuSDK()
        } else {
          this.sdkLoaded = true
          if (this.isCode) this.initLoginQR()
        }
      }
      document.head.appendChild(script)
    },
    // 用户手动刷新二维码：页面内重新渲染，免去整页 F5
    retryFeishuQR() {
      if (this.qrCheckTimer) {
        clearTimeout(this.qrCheckTimer)
        this.qrCheckTimer = null
      }
      this.qrRetryCount = 0
      // SDK 仍未就绪时先补载，避免点了刷新还是空白
      if (!window.QRLogin) {
        this.sdkReloadTried = false
        this.sdkLoaded = false
        this.loadFeishuSDK()
        return
      }
      this.renderFeishuQR()
    },
    initLoginQR() {
      // 默认使用飞书登录
      if (!this.selectedLoginMethod) {
        this.selectedLoginMethod = 'feishu'
      }

      // 清掉上一次未完成的渲染校验定时器
      if (this.qrCheckTimer) {
        clearTimeout(this.qrCheckTimer)
        this.qrCheckTimer = null
      }

      if (this.selectedLoginMethod === 'feishu') {
        // 飞书：交给带 SDK 等待 / 渲染校验 / 自动重试的渲染流程
        this.qrRetryCount = 0
        this.renderFeishuQR()
        return
      }

      const loginContainer = document.getElementById('login_container')
      if (!loginContainer) return
      loginContainer.innerHTML = ''

      if (this.selectedLoginMethod === 'dingding') {
        const url = encodeURIComponent('https://account.suntekcorps.com:8080/login')
        const goto = encodeURIComponent(
          'https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=dingoaxb8dpak3bcozxkpx&response_type=code&scope=snsapi_login&state=STATE&redirect_uri=' +
            url
        )

        // eslint-disable-next-line
        var obj = DDLogin({
          id: 'login_container', // 这里需要你在自己的页面定义一个HTML标签并设置id，例如<div id="login_container"></div>或<span id="login_container"></span>
          goto: goto, // 请参考注释里的方式
          style: 'border:none;background-color:#FFFFFF;padding: 0 10px 10px;',
          width: '250',
          height: '300'
        })
      }
    },
    // 渲染飞书扫码二维码：等待 SDK 就绪 + 容器就绪后注入，再校验是否真的渲染出来
    renderFeishuQR() {
      // SDK 尚未就绪：轮询等待，避免 QRLogin 未定义时报错导致二维码永不出现
      if (!window.QRLogin) {
        if (!this.sdkLoaded) {
          this.qrCheckTimer = setTimeout(() => this.renderFeishuQR(), 150)
          return
        }
        // SDK 标记就绪但仍无 QRLogin：加载失败，提示用下方按钮重试（会重新拉取 SDK）
        const loginContainer = document.getElementById('login_container')
        if (loginContainer) {
          loginContainer.innerHTML =
            '<div style="padding:40px 0;color:#909399;font-size:13px;">飞书登录组件加载失败，请点击下方"点击刷新"重试</div>'
        }
        return
      }

      this.$nextTick(() => {
        const loginContainer = document.getElementById('login_container')
        if (!loginContainer) return

        // 清空容器后注入二维码
        loginContainer.innerHTML = ''
        // eslint-disable-next-line
        window.QRLogin({
          id: 'login_container',
          goto: this.getFeishuGoto(),
          style: 'border:none;background-color:#FFFFFF;',
          width: '300',
          height: '300'
        })

        // 渲染校验：飞书 SDK 会往容器注入 iframe，若超时未出现则自动重试
        this.verifyFeishuQR(loginContainer)
      })
    },
    // 校验二维码是否真正渲染；未渲染则清理重试，把“用户手动刷新几次”变成“页面自动重试几次”
    verifyFeishuQR(loginContainer) {
      const MAX_RETRY = 4
      const CHECK_DELAY = 1500
      this.qrCheckTimer = setTimeout(() => {
        this.qrCheckTimer = null
        // 仍在飞书登录态、且容器里没有 iframe，视为本次渲染失败
        if (this.selectedLoginMethod !== 'feishu' || !this.isCode) return
        const hasIframe = loginContainer && loginContainer.querySelector('iframe')
        // iframe 存在但尺寸为 0 也算渲染失败（与“没有 iframe”同等处理，触发重试）
        const ok = hasIframe && hasIframe.clientHeight > 0 && hasIframe.clientWidth > 0
        if (ok) return

        if (this.qrRetryCount < MAX_RETRY) {
          this.qrRetryCount++
          this.renderFeishuQR()
        } else {
          // 多次仍失败：提示用户用下方的"点击刷新"按钮（页面内重渲，免整页 F5）
          loginContainer.innerHTML =
            '<div style="padding:30px 0;color:#909399;font-size:13px;">二维码加载失败，请点击下方"点击刷新"重试</div>'
        }
      }, CHECK_DELAY)
    },
    handleMessage(event) {
      var origin = event.origin
      if (origin === 'https://login.dingtalk.com') {
        // 防止钉钉SDK多次触发message事件导致重复请求
        if(this.dingLoginProcessing) return;
        this.dingLoginProcessing = true;
        // 处理成功后立即移除监听，防止重复触发
        window.removeEventListener('message', this.handleMessage)
        // 判断是否来自ddLogin扫码事件。
        var loginTmpCode = event.data
        // 获取到loginTmpCode后就可以在这里构造跳转链接进行跳转了
        console.log('loginTmpCode', loginTmpCode)
        this.$store.dispatch('DingLogin', loginTmpCode).then((res) => {
          // 需要二次验证，跳转验证码页面
          if(['0000013','0000014','0000015','0000016'].includes(res.code)){
            let path = this.getVerificationCodePath()
            this.$router.push({ path })
            return
          }
          // 不需要二次验证，直接跳转首页
          toLink().then(path => {
            if (this.redirect) {
              window.location.href = this.redirect
            } else {
              this.$router.push({ path: path })
            }
          })
        }).catch(() => {
          // 失败时恢复监听，允许用户重试
          this.dingLoginProcessing = false;
          window.addEventListener('message', this.handleMessage, false)
        })
      } else if (origin === 'https://passport.feishu.cn') {
        // 防止飞书SDK多次触发message事件导致重复请求
        if(this.fsLoginProcessing) return;
        this.fsLoginProcessing = true;
        // 处理成功后立即移除监听，防止重复触发
        window.removeEventListener('message', this.handleMessage)
        // 判断是否来自飞书扫码事件。
        var loginTmpCode = event.data.tmp_code
        // 获取到loginTmpCode后就可以在这里构造跳转链接进行跳转了
        console.log('feishu loginTmpCode', loginTmpCode)
        window.location.href = `${this.getFeishuGoto()}&tmp_code=${loginTmpCode}`;
      }
    },
    // 验证这个用户是否存在
    checkUser() {
      if (!this.loginForm.username) {
        this.$message({
          message: '用户名不能为空~',
          type: 'warning'
        })
        return false
      } else {
        // 存在
        this.errorMsg = ''
        const params = {
          username: this.loginForm.username,
          state: 1
          // status: 1
        }
        validateUser(params)
          .then((response) => {
            if (response.code === '000000') {
              this.validateFalse = false
              this.$refs.userPwd.focus()
              // 判断是否是老用户
              this.isOldUser = response.data.isOldUser
              if (this.isOldUser === true) {
                this.$confirm(
                  '您是老用户因此要修改密码后才能登陆,是否现在去修改密码?',
                  '提示',
                  {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                  }
                )
                  .then(() => {
                    this.$router.push({ path: 'findPassword' })
                  })
                  .catch(() => {
                    this.$message({
                      type: 'info',
                      message: '已取消'
                    })
                  })
              }
            } else {
              this.errorMsg = response.message
              this.validateFalse = true
            }
          })
          .catch((error) => {
            console.log(error)
          })
      }
    },
    showPwd() {
      if (this.pwdType === 'password') {
        this.pwdType = ''
      } else {
        this.pwdType = 'password'
      }
    },
    handleLogin() {
      if (!this.loginForm.username) {
        this.$message({
          message: '用户名不能为空~',
          type: 'warning'
        })
        return false
      } else {
        this.$refs.loginForm.validate((valid) => {
          if (valid) {
            this.loading = true
            this.$store
              .dispatch('Login', this.loginForm)
              .then((res) => {
                this.loading = false
                if(['0000013','0000014','0000015','0000016'].includes(res.code)){
                  let path = this.getVerificationCodePath()
                  this.$router.push({ path })
                  return
                }
                if(res.code === '000000'){
                   toLink().then(path => {
                    console.log(path, 'dd')
                    console.log(this.redirect, 'redirect',path)
                    if (this.redirect) {
                      if(this.redirect.indexOf('jumpServer') > -1){
                          let object = {
                            // userId: res.data.userInfo.userId,
                            // systemCode: item.usId,
                            // username: res.data.userInfo.name,
                            // ip: Cookies.get('userIp'),
                            token: res.data.token
                          }
                          object = JSON.stringify(object)
                          const Base64 = require('js-base64').Base64
                          const urlCode = Base64.encode(object)
                          const url = this.redirect.split('?')[0]
                          window.location.href = url+'core/auth/login/new/?code='+urlCode
                          return
                      }
                      window.location.href = this.redirect
                    } else {
                      // this.$router.push({ path: path })
                      this.$router.push({ path: '/' })
                    }
                  })
                }
                console.log(toLink,toLink(),'toLink')
                // utils公共方法获取面板配置，跳转地址path 这部分方法挪到验证码处
                // toLink().then(path => {
                //   console.log(path, 'dd')
                //   console.log(this.redirect, 'redirect',path)
                //   if (this.redirect) {
                //     window.location.href = this.redirect
                //   } else {
                //     // this.$router.push({ path: path })
                //     this.$router.push({ path: '/verificationCode' })
                //   }
                // })

                // const usId = this.$route.query.usId;
                // if (info.userInfo.departmentId === 38996) { //此部门跳转新用户中心页面  8组测试 592  正式 38996
                //   if (usId) {
                //     this.$router.push({
                //       path: "/" || "/userCenter",
                //       query: { usId: usId },
                //     });
                //   } else {
                //     // this.$router.push({ path: '/' || '/userCenter' })
                //     this.$router.push({ path: "/resetPassword" });
                //   }
                // } else {
                //   this.$router.push({ path: "/userCenterOld" });
                // }
                // 因为进度条（NProgress）问题，所以把获取用户信息改到进度条控制器中
                // this.$store.dispatch("GetUserInfo").then(()=>{
                //   this.isFirstLogin = this.$store.getters.roles.userInfo.isFirstLogin;
                // console.log("isFirstLogin", this.isFirstLogin);
                // this.loading = false;
                // if (this.isFirstLogin === true) {
                //   this.$router.push({ path: "resetPassword" });
                // } else {
                //   this.$router.push({ path: this.redirect || "/userCenter" });
                //   // this.$router.push({ path: this.redirect || "/" });
                // }
                // })
              })
              .catch(() => {
                this.loading = false
              })
          } else {
            console.log('error submit!!')
            return false
          }
        })
      }
    }
    // toLink() {
    //   // 跳转看板在点击登录和扫码登录都需要判断，抽调成公共的
    //   const info = getPowerInfo()
    //   // 获取公司架构，查询用户部门是否配置看板，如果有跳看板页面，没有跳旧用户中心
    //   getDepartTree()
    //     .then((res) => {
    //       const data = res.data
    //       if (data.length > 0) {
    //         // 查询 用户 树形部门 通过多个部门 如果风格都设置了 取最接近部门的风格
    //         const newLevel = this.getParent(
    //           data,
    //           info.userInfo.departmentId,
    //           info.userInfo.userId
    //         )
    //         const params = {
    //           userId: newLevel
    //         }
    //         getStyle(params)
    //           .then((res) => {
    //             if (res.data.length > 0) {
    //               this.$router.push({ path: '/userCenterNew' })
    //             } else {
    //               this.$router.push({ path: '/' })
    //             }
    //           })
    //           .catch(() => {
    //             this.$router.push({ path: '/' })
    //           })
    //       } else {
    //         this.$router.push({ path: '/' })
    //       }
    //     })
    //     .catch(() => {})
    // },
    // getParent(data, id, userId) {
    //   let idStr = ''
    //   function find(data, id) {
    //     data.forEach((item) => {
    //       if (item.udId === id) {
    //         idStr = item.longId
    //       } else if (item.children) {
    //         find(item.children, id)
    //       }
    //     })
    //   }
    //   find(data, id)
    //   const ids = idStr.split('-')
    //   ids.push(userId)
    //   return ids.filter((i) => i !== '').join(',')
    // }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
$bg: #2d3a4b;
$light_gray: #eee;

/* reset element-ui css */
.login-container {
  .el-input {
    display: inline-block;
    height: 47px;
    width: 85%;
    input {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      color: $light_gray;
      height: 47px;
      &:-webkit-autofill {
        -webkit-box-shadow: 0 0 0px 1000px $bg inset !important;
        -webkit-text-fill-color: #fff !important;
      }
    }
  }
  .el-form-item {
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    color: #454545;
  }
}
</style>

<style rel="stylesheet/scss" lang="scss" scoped>
$bg: #2d3a4b;
$dark_gray: #889aa4;
$light_gray: #eee;
.login-container {
  position: fixed;
  height: 100%;
  width: 100%;
  background-color: $bg;
  .login-form {
    position: absolute;
    left: 0;
    right: 0;
    width: 520px;
    max-width: 100%;
    padding: 35px 35px 15px 35px;
    margin: 120px auto;
    .code-tab {
      width: 100%;
      text-align: center;
      .qrcode-box {
        .qrcode-card {
          position: relative;
          display: inline-block;
          padding: 0;
          line-height: 0;
          overflow: hidden;
          border-radius: 12px;
        }
        #login_container {
          display: block;
          width: 280px;
          height: 280px;
          line-height: 0;
          overflow: hidden;
        }
        #login_container ::v-deep iframe {
          display: block;
          transform: translate(-10px, -10px);
        }
        .fs-corner {
          position: absolute;
          width: 22px;
          height: 22px;
          border: 3px solid #3370FF;
        }
        .fs-corner--tl { top: 12px; left: 12px; border-right: none; border-bottom: none; border-top-left-radius: 6px; }
        .fs-corner--tr { top: 12px; right: 12px; border-left: none; border-bottom: none; border-top-right-radius: 6px; }
        .fs-corner--bl { bottom: 12px; left: 12px; border-right: none; border-top: none; border-bottom-left-radius: 6px; }
        .fs-corner--br { bottom: 12px; right: 12px; border-left: none; border-top: none; border-bottom-right-radius: 6px; }
      }
      .qr-hint {
        margin-top: 18px;
        font-size: 14px;
        color: #a0aec0;
        b { color: #6ea0ff; font-weight: 600; }
      }
      .qr-refresh {
        margin: 6px 0 0;
        font-size: 12px;
        color: #6ea0ff;
        cursor: pointer;
        &:hover { text-decoration: underline; }
      }
      .security-tip {
        margin: 15px 0 0;
        font-size: 12px;
        color: rgba(255, 255, 255, 0.5);
        line-height: 1.5;
      }
    }
  }
  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;
    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }
  .svg-container {
    padding: 6px 5px 6px 15px;
    color: $dark_gray;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
  }
  .title {
    font-size: 32px;
    font-weight: 400;
    color: $light_gray;
    margin: 0px auto 40px auto;
    text-align: center;
    font-weight: bold;
  }
  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }
  .hidden-toggle-btn {
    opacity: 0.06;
    font-size: 16px;
    padding: 4px;
    color: #6b7a8a;
    cursor: default;
  }
  .corner-toggle-btn {
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 10;
  }
  // loginMode=qr：账号密码登录与扫码登录的切换入口需可见可点，其它场景维持隐藏态
  .corner-toggle-btn--visible {
    opacity: 1;
    color: #c6c8d1;
    cursor: pointer;
    &:hover {
      color: #fff;
    }
  }
  .clear {
    clear: both;
  }
}
.logo {
  position: absolute;
  display: flex;
  height:60px;
  line-height: 60px;
  left: 5px;
  top: 10px;
  vertical-align: middle;
  color:#fff;
}
.footer-bottom {
  line-height: 44px;
  flex-grow: 1;
  font-size: 14px;
  position: absolute;
  bottom: 0;
  font-weight: 500;
  color: #c6c8d1;
  text-align: center;
  width: 100%;
  border-top: 1px solid #3f3b5c;
}

</style>
